import { forwardRef as i } from "react";
import "../../../../Button/Button.js";
import { IconButton as e } from "../../../../Button/IconButton/IconButton.js";
import "@material-bank/ds-utils";
import "@material-bank/mb-icons";
import "theme-ui";
import "@theme-ui/css";
import "../../../../../lib/css/match-media-context.js";
import { jsx as m } from "theme-ui/jsx-runtime";
const c = i((r, n) => {
  const {
    getToggleButtonProps: o,
    /* eslint-disable @typescript-eslint/no-unused-vars */
    getInputProps: s,
    selectedOption: u,
    /* eslint-enable @typescript-eslint/no-unused-vars */
    ...p
  } = r, t = {
    ref: n,
    ...p
  };
  return /* @__PURE__ */ m(e, {
    ...(o == null ? void 0 : o(t)) ?? t
  });
});
c.displayName = "SelectIconButtonTrigger";
export {
  c as SelectIconButtonTrigger
};
